import type { FirstRunGuardProps } from '@/components/FirstRunGuard.types';
import { OnboardingGuard } from '@/components/OnboardingGuard';
import { PiiTrainingGuard } from '@/components/PiiTrainingGuard';

/** First-run gates for app routes, in order: onboarding, then PII training. */
export const FirstRunGuard = ({ children }: FirstRunGuardProps) => (
  <OnboardingGuard>
    <PiiTrainingGuard>{children}</PiiTrainingGuard>
  </OnboardingGuard>
);
